import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import jaJP from 'vant/es/locale/lang/ja-JP';

const SUPPORTED = ['en', 'zh', 'ja', 'kr'];

const VANT_LOCALES = {
  en: { id: 'en-US', pack: enUS },
  zh: { id: 'zh-CN', pack: zhCN },
  ja: { id: 'ja-JP', pack: jaJP },
  kr: { id: 'en-US', pack: enUS },
};

export function normalizeLocale(code) {
  const c = String(code || 'en').toLowerCase();
  return SUPPORTED.indexOf(c) >= 0 ? c : 'en';
}

export function backendLangFrom(code) {
  const map = { zh: 'zh', en: 'en', ja: 'jp', kr: 'kr' };
  return map[normalizeLocale(code)] || 'en';
}

export function applyVantLocale(code) {
  const locale = normalizeLocale(code);
  const hit = VANT_LOCALES[locale] || VANT_LOCALES.en;
  Locale.use(hit.id, hit.pack);
}

export function applySiteLocale(i18n, code) {
  const locale = normalizeLocale(code);
  if (i18n) i18n.locale = locale;
  localStorage.setItem('lang', locale);
  document.documentElement.lang = locale === 'zh' ? 'zh-CN' : locale === 'ja' ? 'ja' : locale === 'kr' ? 'ko' : 'en';
  applyVantLocale(locale);
  return locale;
}

export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English', native: 'United States', flag: '🇺🇸', color: 'linear-gradient(135deg,#60a5fa,#3b82f6)' },
  { code: 'zh', name: '简体中文', native: 'Chinese', flag: '🇨🇳', color: 'linear-gradient(135deg,#ef4444,#dc2626)' },
  { code: 'ja', name: '日本語', native: 'Japanese', flag: '🇯🇵', color: 'linear-gradient(135deg,#fb7185,#e11d48)' },
  { code: 'kr', name: '한국어', native: 'Korean', flag: '🇰🇷', color: 'linear-gradient(135deg,#c084fc,#a020f0)' },
];

/** Pick localized segment from CSV name (kr,en,ja,zh). */
export function pickLocaleName(raw, locale) {
  const parts = String(raw || '').split(',').map(s => s.trim());
  if (parts.length >= 4) {
    const idx = { kr: 0, en: 1, ja: 2, zh: 3 }[normalizeLocale(locale)] ?? 1;
    return parts[idx] || parts[1] || parts[0] || '';
  }
  return String(raw || '').trim();
}
